export default __webpack_public_path__ + "static/media/favicon.ec700054.ico";